<template>
  <div
    class="bus"
    v-if="map.length"
  >
    <div class="bus--title">
      <slot name="title" />
    </div>
    <div class="bus--caption">
      <slot name="category" />
    </div>
    <div class="bus--seats">
      <div class="bus--section">
        <span>FRENTE</span>
      </div>
      <table>
        <tr
          v-for="(row, r) in map"
          :key="r"
        >
          <td>{{ r + 1 }}</td>
          <template v-for="(seat, c) in row">
            <td
              v-if="seat && SEAT_STATUS[seat.status]"
              class="bus--seat"
              :class="'bus--seat--' + seat.status"
              @click="$emit('click', seat)"
            >
              <seat-tooltip :seat="seat" />
              <seat-icon :fill="SEAT_STATUS[seat.status]" />
            </td>
            <td v-else>
              <span class="bus--path" />
            </td>
          </template>
          <td>{{ r + 1 }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SeatIcon from '@/components/SeatIcon'
import SeatTooltip from '@/components/SeatTooltip'
import { SEAT_STATUS } from '@/constans'

export default {
  components: { SeatIcon, SeatTooltip },

  props: ['map', 'tooltips'],

  name: 'Bus',

  data () {
    return {
      SEAT_STATUS
    }
  }
}
</script>
<style lang="css" scoped>
.bus__hover .bus--seat.bus--seat--picked{
	cursor: pointer;
}
svg{
	max-width: 26px;
	max-height: 26px;
}
</style>
